<template>
  <ElTooltip :content="$t('EDIT')" placement="top">
    <ElButton
      class="table-cell-edit__button"
      plain
      size="mini"
      icon="el-icon-edit"
      @click="openEditModal"
    />
  </ElTooltip>
</template>

<script>
import TableCellEditModal from './TableCellEditModal';

export default {
  name: 'TableCellEdit',

  props: {
    title: {
      type: String,
      default: '',
    },
    // eslint-disable-next-line vue/require-prop-types
    initialValue: {
      // can have any type
      default: null,
    },
  },

  methods: {
    openEditModal() {
      this.$modal
        .open({
          title: this.$t('EDIT') + ' ' + this.title,
          component: TableCellEditModal,
          props: {
            key: this.initialValue,
            initialValue: this.initialValue,
            ...this.$attrs,
          },
          width: '20%',
        })
        .then(newValue => {
          // should be able to emit other falsy values
          if (newValue !== undefined) {
            this.$emit('save', newValue);
          }
        });
    },
  },
};
</script>

<style lang="scss">
.table-cell-edit {
  &__button {
    padding-left: $--button-mini-padding-vertical;
    padding-right: $--button-mini-padding-vertical;
    margin-left: $global-margin;

    @include rtl() {
      margin-right: calc($global-margin / 2);
    }
  }
}
</style>
